/**
 * @summary Remove monitoringElementChilde nulos do array.
 * @param {Array} monitoringElements
 * @returns {Array} Retorna um array de monitoringElements sem a propriedade monitoringElementChild se ela for nula.
 */
const CreateMonitoringElementsTreeMenu = (monitoringElements) =>
{
	const newMonitoringElements = [];

	for (let i = 0; i < monitoringElements.length; i++)
	{
		const children = monitoringElements[i].monitoringElementChild;
		if (Array.isArray(children) && children.length)
		{
			newMonitoringElements[i] = monitoringElements[i];
			newMonitoringElements[i].monitoringElementChild = CreateMonitoringElementsTreeMenu(children);
		}
		else
		{
			const monitoringElement = Object.assign(monitoringElements[i]);
			delete monitoringElement.monitoringElementChild;
			newMonitoringElements.push(monitoringElement);
		}
	}
	return newMonitoringElements;
};

/**
 * @summary verifica se monitoringElement ou os filhos do monitoringElement possuem o Id procurado
 * @param {Number} monitoringElementId - Id do monitoringElement
 * @param {Array} monitoringElements - Array de monitoringElements
 * @returns {Boolean} Retorna true se o monitoringElement tem este Id.
 */
const IsThereAMonitoringElementInTreeMenu = function(monitoringElementId, monitoringElements)
{
	let elementFound = false;
	if (monitoringElements && monitoringElements.length > 0)
	{
		for (let i = 0; i < monitoringElements.length; i++)
		{
			const Id = monitoringElementId.toString();
			const elementId = monitoringElements[i].id.toString();
			// Id do monitoringElement é igual ao Id passado como parametro.
			if (elementId === Id)
			{
				elementFound = true;
				// Sai do for.
				break;
			}
			// MonitoringElement não foi encontrado. Verifica se tem filhos e começa uma função recursiva.
			if (!!monitoringElements[i].monitoringElementChild)
			{
				const isThereAMonitoringElementInTreeMenu =
				IsThereAMonitoringElementInTreeMenu(monitoringElementId, monitoringElements[i].monitoringElementChild);
				if (isThereAMonitoringElementInTreeMenu) return isThereAMonitoringElementInTreeMenu;
			}
		}
	}
	return elementFound;
};

export default { CreateMonitoringElementsTreeMenu, IsThereAMonitoringElementInTreeMenu };
